import { baseApi } from "@/shared/api";
import { type PersonalInfoDto, type PersonalInfoPostResponse, type PersonalInfoResponse } from "./types";

export const personalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalInfo: builder.query<PersonalInfoResponse, string>({
      query: (token) => `/api/hr/apply/${token}/personal/`,
      providesTags: ["Completeness"],
    }),

    createPersonalInfo: builder.mutation<PersonalInfoPostResponse, { token: string; body: Partial<PersonalInfoDto> }>({
      query: ({ token, body }) => {
        const formData = new FormData();

        if (body.iin !== undefined) formData.append("iin", body.iin);
        if (body.name !== undefined) formData.append("name", body.name);
        if (body.surname !== undefined) formData.append("surname", body.surname);
        if (body.father_name !== undefined) formData.append("father_name", body.father_name ?? "");
        if (body.date_of_birth !== undefined) formData.append("date_of_birth", body.date_of_birth);
        if (body.gender !== undefined) formData.append("gender", body.gender);
        if (body.family_status !== undefined) formData.append("family_status", body.family_status);

        if (body.city_of_birth_id !== undefined) {
          formData.append("city_of_birth_id", body.city_of_birth_id !== null ? String(body.city_of_birth_id) : "null");
          formData.append("city_of_birth_other", "null");
        } else if (body.city_of_birth_other !== undefined) {
          formData.append("city_of_birth_id", "null");
          formData.append("city_of_birth_other", body.city_of_birth_other !== null ? body.city_of_birth_other : "null");
        }

        if (body.nationality !== undefined) formData.append("nationality", body.nationality);
        if (body.citizenship !== undefined) formData.append("citizenship", body.citizenship);
        if (body.is_resident !== undefined) formData.append("is_resident", String(body.is_resident));
        if (body.is_student !== undefined) formData.append("is_student", String(body.is_student));
        if (body.enrollment_start_date !== undefined) {
          formData.append("enrollment_start_date", body.enrollment_start_date ?? "");
        }
        if (body.enrollment_end_date !== undefined) {
          formData.append("enrollment_end_date", body.enrollment_end_date ?? "");
        }

        if (body.photo_file) formData.append("photo_file", body.photo_file);
        if (body.enrollment_verification_file) formData.append("enrollment_verification_file", body.enrollment_verification_file);

        return {
          url: `/api/hr/apply/${token}/personal/`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Completeness"],
    }),
  }),
});

export const { useGetPersonalInfoQuery, useCreatePersonalInfoMutation } = personalApi;
